export const imageAccommodation = {
  breadcrumbCurrent: "Logo da acomodação",
  heading: "O logo do seu anúncio",
  subtitle:
    "Envie o logo que identifica este anúncio. Formatos permitidos: PNG, JPG, SVG · máx. 5 MB.",
  savedLogoAlt: "Logo salvo",
  activeBadge: "Logo ativo",
  change: "Alterar",
  drop: {
    release: "Solte aqui",
    newLogo: "Novo logo",
    uploadLogo: "Envie seu logo",
    dragOr: "Arraste ou",
    clickLink: "clique",
    formats: "PNG · JPG · SVG · máx. 5 MB",
  },
  importButton: "Importar logo de outro anúncio",
  crop: {
    removeImage: "Remover imagem",
    tip: "Mova e ajuste o recorte. Proporção 2:1 (ideal para logos horizontais).",
    saving: "Salvando…",
    save: "Salvar logo",
  },
  actions: {
    cancel: "Cancelar",
  },
  applyModal: {
    title: "Aplicar a outros anúncios?",
    subtitle: "Selecione os anúncios para os quais deseja copiar este mesmo logo.",
    logoAlt: "Logo",
    selectAll: "Selecionar todos",
    progress: "Aplicando {done}/{total}…",
    skip: "Pular",
    applying: "Aplicando…",
    applyToBtn: "Aplicar a {count} anúncio | Aplicar a {count} anúncios",
  },
  importModal: {
    title: "Importar logo",
    subtitle: "Escolha o logo de outro anúncio para usar neste.",
    loading: "Carregando anúncios…",
    empty: "Nenhum anúncio tem logo ainda.",
    progress: "Importando logo…",
    importing: "Importando…",
  },
  defaultListingName: "Anúncio",
  toasts: {
    invalidFormat: "Formato inválido. Use PNG, JPG ou SVG.",
    fileTooLarge: "O arquivo excede o limite de {max} MB.",
    selectBeforeSave: "Selecione e ajuste um logo antes de salvar.",
    propertyNotFound: "A propriedade vinculada a este anúncio não foi encontrada.",
    saveSuccess: "Logo salvo com sucesso",
    saveError: "Erro ao salvar o logo.",
    listingLoadError: "Não foi possível carregar os detalhes do anúncio.",
    applySuccess:
      "Logo aplicado a {count} anúncio com sucesso | Logo aplicado a {count} anúncios com sucesso",
    applyError:
      "Não foi possível aplicar a {count} anúncio | Não foi possível aplicar a {count} anúncios",
    listingsLoadError: "Não foi possível carregar os anúncios.",
    propertyNotFoundImport: "A propriedade deste anúncio não foi encontrada.",
    importSuccess: 'Logo de "{name}" importado com sucesso',
    importError: "Erro ao importar o logo.",
  },
};
